import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4725419f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepSenders" }
const _hoisted_2 = {
  key: 1,
  class: "px-6 py-4 bg-white border"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "StepSenders__title" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "StepSenders__state mt-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message message--failed" }, " Произошла ошибка при загрузке списка отправителей ", -1))
const _hoisted_10 = {
  key: 1,
  class: "StepSenders__list"
}
const _hoisted_11 = {
  key: 0,
  class: "StepSenders__state mt-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Список пуст", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "text-gray-400 font-semibold text-sm mt-3 select-none"
}
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = {
  class: "list__wrapper",
  ref: "templatewindow"
}
const _hoisted_17 = {
  key: 2,
  class: "StepSenders__state mt-2"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "state__message" }, "Загрузка списка отправителей...", -1))
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "px-6 py-4 bg-white border" }
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepSenders__title" }, "Отправитель", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_24 = { class: "StepSenders__sender mt-2" }
const _hoisted_25 = { class: "sender__title" }
const _hoisted_26 = { class: "mt-2 text-sm" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-user mr-2" }, null, -1))
const _hoisted_29 = { class: "block" }
const _hoisted_30 = { class: "flex items-center mt-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-mobile mr-3" }, null, -1))
const _hoisted_32 = { class: "block" }
const _hoisted_33 = { class: "flex items-center mt-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon fas fa-map-marker-alt mr-3" }, null, -1))
const _hoisted_35 = { class: "block" }
const _hoisted_36 = {
  key: 0,
  class: "mt-2 font-semibold"
}
const _hoisted_37 = {
  key: 0,
  class: "flex items-center justify-end"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_templates_actions = _resolveComponent("templates-actions")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_senders_list_item = _resolveComponent("senders-list-item")!
  const _component_loader = _resolveComponent("loader")!
  const _component_additional_services = _resolveComponent("additional-services")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_templates_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": false,
          loading: _ctx.actions_state.is_actions_loading,
          companyId: _ctx.companyId,
          "initial-value": _ctx.actions_state.initial_value,
          "is-sender": true,
          "sender-city-id": _ctx.cityId,
          "city-id": _ctx.cityId,
          "is-express": _ctx.isExpress,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onSenderCreate,
          onUpdate: _ctx.onSenderUpdate
        }, null, 8, ["is-create", "is-update", "loading", "companyId", "initial-value", "sender-city-id", "city-id", "is-express", "onCreate", "onUpdate"]))
      : _createCommentVNode("", true),
    (!_ctx.state.is_sender_selected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.stepNumber) + ". Выберите отправителя", 1),
            (_ctx.opened)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.excelMultipleOrder)
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 0,
                        class: "primary small text",
                        disabled: _ctx.disabled,
                        onClick: _ctx.onExcelMultipleOrder
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _createTextVNode(" Оптовое создание заказов для EXCEL ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_the_button, {
                    class: "primary small text",
                    disabled: _ctx.disabled,
                    onClick: _ctx.startCreate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" Новый отправной пункт ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.opened)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.data_state.senders.is_failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_the_button, {
                        class: "primary small mt-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSenders(_ctx.data_state.senders.pagination.current_page)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Обновить ")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_the_input, {
                        value: _ctx.state.search_query,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.search_query) = $event)),
                        disabled: _ctx.disabled,
                        placeholder: "Поиск по номеру телефона, адресу и названию",
                        class: "mt-2 w-full",
                        onInput: _ctx.searchSender
                      }, null, 8, ["value", "disabled", "onInput"]),
                      (
                            !_ctx.data_state.senders.is_loading && _ctx.data_state.senders.list.length === 0
                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                        : _createCommentVNode("", true),
                      (!_ctx.data_state.senders.is_loading && _ctx.data_state.senders.list.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("span", null, "Страница: " + _toDisplayString(_ctx.data_state.senders.pagination.current_page), 1),
                            _createElementVNode("span", _hoisted_15, "Отправителей: " + _toDisplayString(_ctx.data_state.senders.list.length), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.senders.list, (sender) => {
                          return (_openBlock(), _createBlock(_component_senders_list_item, {
                            class: "StepSenders__item",
                            key: sender,
                            item: sender,
                            disabled: _ctx.disabled,
                            onSubmit: _ctx.onSenderSelect,
                            onUpdate: _ctx.startUpdate,
                            onDeleted: _ctx.onSenderDeleted
                          }, null, 8, ["item", "disabled", "onSubmit", "onUpdate", "onDeleted"]))
                        }), 128))
                      ], 512)
                    ])),
                (_ctx.data_state.senders.is_loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_18
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_the_button, {
                class: "second small text",
                disabled: _ctx.disabled,
                onClick: _ctx.emitReset
              }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.state.sender.title), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.state.sender.full_name), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.state.sender.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.state.sender.full_address), 1)
                ]),
                (Boolean(_ctx.state.sender.warehouse_id))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, " Самопривоз "))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.isAdditionalServicesVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_the_button, {
                    class: "primary text small",
                    disabled: _ctx.disabled,
                    onClick: _ctx.openAdditionalServices
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38,
                      _createTextVNode(" Установить доп. услуги ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (
                    _ctx.isAdditionalServicesVisible &&
                    (_ctx.state.is_additional_services_opened || _ctx.state.is_additional_services_setted)
                )
            ? (_openBlock(), _createBlock(_component_additional_services, {
                key: 0,
                class: "mt-3",
                "is-additional-services-visible": _ctx.isAdditionalServicesVisible,
                setted: _ctx.state.is_additional_services_setted,
                disabled: _ctx.disabled,
                "initial-value-ftl": _ctx.additionalService,
                onSubmit: _ctx.onAdditionalServicesSubmit,
                onReset: _ctx.onAdditionalServicesReset
              }, null, 8, ["is-additional-services-visible", "setted", "disabled", "initial-value-ftl", "onSubmit", "onReset"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}